import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ArrowLeftRight } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTransfer } from '../../api/transfers/create-transfer'
import UserNavBar from '../../components/elements/nav-bar'
import TransferForm from '../../components/pages/transfers/transfer-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

const TransferCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTransfer,
    onError: showAxiosError,
    onSuccess: () => toast.success('Transfert créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un transfert'} icon={ArrowLeftRight} />
      <div className={'h-4'} />

      <Box>
        <TransferForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.TRANSFER_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.TRANSFER_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}

export default TransferCreatePage
